export default "__VITE_ASSET__CjTUf0Up__"